import { EnvService } from 'src/services/env.service';
import { Component, OnInit } from '@angular/core';
import { BaseComponent, WaitComponent } from '@sircon/sircon-ui-framework';
import { CarrierInformation } from 'src/app/core/models/carrier-information.model';
import { ActivatedRoute } from '@angular/router';
import { CarrierService } from 'src/services/carrier.service';
import { catchError, finalize, of, takeUntil, tap } from 'rxjs';
import { NgIf } from '@angular/common';

/**
 * Controller for the public (unauthenticated) header component
 */
@Component({
    selector: 'app-public-header-black-logo',
    styleUrls: ['./public-header-black-logo.component.less'],
    templateUrl: './public-header-black-logo.component.html',
    imports: [NgIf, WaitComponent]
})
export class PublicHeaderBlackLogoComponent extends BaseComponent implements OnInit {
    environmentLabel;
    brandKey;
    entityType;
    loadingBrand;
    carrierInformation: CarrierInformation;

    constructor(
        private env: EnvService,
        private route: ActivatedRoute,
        private carrierService: CarrierService
    ) {
        super();
    }

    ngOnInit() {
        this.environmentLabel = this.env.LABEL;
        this.brandKey = this.route.snapshot.queryParams.brandKey;
        this.entityType = this.route.snapshot.queryParams.entityType;
        this.loadBrandInformation();
    }

    loadBrandInformation() {
        if (this.brandKey) {
            this.loadingBrand = true;
            this.carrierService.getCarrierByBrand(this.brandKey)
                .pipe(
                    tap((response => {
                        this.carrierInformation = response;
                    })),
                    catchError(() => {
                        // When there is an error fallback to normal login. The error is displayed on the main component
                        this.brandKey = null;
                        return of(null);
                    }),
                    finalize(() => {
                        this.loadingBrand = false;
                    }),
                    takeUntil(this.ngUnsubscribe)
                )
                .subscribe();
        }
    }
}

